var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureStream(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a42",
    x1: 11.08,
    y1: 31.2,
    x2: 11.08,
    y2: 15.71,
    gradientTransform: "matrix(1 0 0 .99 0 -14.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#aeafb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6b8b9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.69V7.9l-.1-.09-1.84-.62L15.59 6l.91-1.88.1-.21-.6-.61-.7-.69-.24.12-1.8.91-1.21-.34-.78-2H9.48l-.09.09-.62 1.83-1.26.47-2.08-1-1.28 1.25.12.24L5.23 6a6 6 0 013.2-.86A6.26 6.26 0 0112 6.28a3.32 3.32 0 01.36.26 3.25 3.25 0 01.93 1.35A3 3 0 0113.5 9a3.23 3.23 0 01-3.25 3.23 3.27 3.27 0 01-1.87-.59 6.31 6.31 0 01-4 1.75l-.19.39 1.28 1.29.26-.07 1.8-1 1.24.51.79 2.16h1.8l.07-.25.64-1.91 1.22-.51 2.11 1 1.27-1.26-.12-.24-.93-1.79.38-1.25z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.65A3.6 3.6 0 011.44 9.6a.46.46 0 11.65-.6A2.65 2.65 0 004 9.73 2.62 2.62 0 005.88 9a3.55 3.55 0 012.55-1A3.64 3.64 0 0111 9a.46.46 0 11-.65.65 2.69 2.69 0 00-1.89-.78 2.61 2.61 0 00-1.88.78 3.61 3.61 0 01-2.58 1z",
    fill: "#50e6ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.82a1.79 1.79 0 01-1.26-.52.46.46 0 01.65-.65.84.84 0 00.61.25 1.08 1.08 0 00.6-.25 5.46 5.46 0 017.67 0 .46.46 0 01-.65.65 4.55 4.55 0 00-6.41 0A1.94 1.94 0 014 8.82z",
    fill: "#50e6ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.48a5.41 5.41 0 01-3.87-1.59.47.47 0 010-.64.47.47 0 01.66 0A4.47 4.47 0 004 11.57a4.5 4.5 0 003.2-1.33 1.94 1.94 0 011.21-.49 1.83 1.83 0 011.25.52.46.46 0 010 .65.47.47 0 01-.66 0 .83.83 0 00-.59-.25 1 1 0 00-.6.26A5.41 5.41 0 014 12.48z",
    fill: "#32bedd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureStream);
export default __webpack_public_path__ + "static/media/azure-stream.712cc4efab0cfaba98d2dbcb9b238c0f.svg";
export { ForwardRef as ReactComponent };